import { render, staticRenderFns } from "./project-rules.component.vue?vue&type=template&id=9bec31fa&scoped=true&"
import script from "./project-rules.component.vue?vue&type=script&lang=ts&"
export * from "./project-rules.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-rules.component.vue?vue&type=style&index=0&id=9bec31fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bec31fa",
  null
  
)

export default component.exports